import humps from 'humps'

export function cloneObj(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function buildKanbanColumns(kanbanResults) {
  if (!kanbanResults) return []
  return Object.values(kanbanResults).map(column => {
    const { name = '', slug = '', nextOffset, allowedMoves = [] } = column?.metadata ?? {}
    return {
      id: humps.camelize(slug),
      parentId: 'root',
      title: name,
      nextOffset,
      totalChildrenCount: 0,
      allowedMoves,
    }
  })
}

export function formatDataForKanban({ prevData, kanbanColumns, kanbanResults }) {
  const newDataSource = {
    root: {
      ...prevData.root,
      children: kanbanColumns.map(v => v.id),
      totalChildrenCount: kanbanColumns.length,
    },
  }

  // Add columns to dataSource
  kanbanColumns.forEach(col => {
    const columnId = col.id

    const serviceOrdersForColumn = kanbanResults[columnId]?.content || []

    // Create card IDs for this column
    const cardIds = serviceOrdersForColumn.map(order => `card-${order.id}`)

    // Add column with its cards
    newDataSource[columnId] = {
      ...col,
      children: cardIds,
      totalChildrenCount: cardIds.length,
    }

    // Add individual cards to dataSource
    serviceOrdersForColumn.forEach(order => {
      const cardId = `card-${order.id}`
      newDataSource[cardId] = {
        id: cardId,
        title: `Chamado ${order.id}`,
        content: order,
        parentId: columnId,
        children: [],
        totalChildrenCount: 0,
        type: 'card',
      }
    })
  })

  return newDataSource
}
